<template>
  <b-row>
    <b-col cols="12">
      <hr class="my-1">
      <span class="h6 float-left">{{$t("views.agreements.form.additionalItems")}}: </span>
    </b-col>
    <b-col>
      <table v-if="data.agreementAdditionalItems && data.agreementAdditionalItems.length > 0" class="table table-responsive-md table-sm table-hover not-border-table">
        <thead class="text-center">
        <tr>
          <th style="width: 4%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.lp')}}</p>
          </th>
          <th style="width: 3%">
            <i class="fa fa-clock fa-lg" v-b-tooltip :title="$t('buttons.cyclicItem')"></i>
          </th>
          <th style="width: 3%">
            <i class="fa fa-percentage fa-lg" v-b-tooltip :title="$t('buttons.promotion')"></i>
          </th>
          <th style="width: 20%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.item')}}</p>
          </th>
          <th style="width: 20%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.valueNetto')}}</p>
          </th>
          <th style="width: 10%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.vatRate')}}</p>
          </th>
          <th style="width: 10%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.vatAmount')}}</p>
          </th>
          <th style="width: 20%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.valueBrutto')}}</p>
          </th>
          <th style="width: 10%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.promotionDifference')}}</p>
          </th>
          <th style="width: 5%"></th>
        </tr>
        </thead>
        <tbody v-for="(item, index) in data.agreementAdditionalItems" :key="index">
        <tr v-if="items && items.length > 0">
          <td><span class="h6"> {{ index + 1 }} </span></td>
          <!--    TOWAR-->
          <td>
            <b-form-checkbox
              :id="`additionalcheckbox-${index}`"
              v-model="item.isCyclic"
              :name="`additionalcheckbox-${index}`"
              :value="1"
              :unchecked-value="0"
              :disabled="!item.canBeCyclic || !item.item"
            >
            </b-form-checkbox>
          </td>
          <td>
            <b-form-checkbox
              :id="`additionalcheckboxpromotion-${index}`"
              v-model="item.hasPromotion"
              :name="`additionalcheckboxpromotion-${index}`"
              :value="true"
              :unchecked-value="false"
              :disabled="hasItemCustomPrices(index)"
            >
            </b-form-checkbox>
          </td>
          <td>
            <model-select v-if="data.agreementAdditionalItems.length > 0"
                          v-model="data.agreementAdditionalItems[index].item"
                          :options="itemOptions"
                          :placeholder="$t('views.agreements.form.select')"
                          name="item">
            </model-select>
          </td>
          <!--    WARTOŚĆ NETTO-->
          <td class="pt-0 pb-0">
            <input type="number" disabled="true" :value="getPriceNetto(index)" class="form-control">
          </td>
          <!--    STAWKA VAT-->
          <td>
            <input type="text" disabled="true" :value="getVatRate(index)" class="form-control">
          </td>
          <!--    WARTOŚĆ VAT-->
          <td>
            <input type="number" disabled="true" :value="getVatValue(index)" class="form-control">
          </td>
          <!--    WARTOŚĆ BRUTTO-->
          <td v-if="hasItemCustomPrices(index)">
            <model-select :options="priceOptions[index]" v-model="data.agreementAdditionalItems[index].priceUserData"></model-select>
          </td>
          <td v-else>
            <input type="number" disabled="true" :value="getPriceBrutto(index)" class="form-control">
          </td>
          <td>
            <input v-if="item.item" type="number" disabled="true" :value="(getPriceBrutto(index) - getItemById(getCurrentItem(index).item).priceBrutto).toFixed(2)" class="form-control">
          </td>
          <td>
              <button
                type="button"
                class="btn btn-link fa fa-trash fa-lg"
                @click="removePosition(index)"
                v-b-tooltip :title="$t('buttons.delete')">
              </button>
          </td>
        </tr>
        <tr v-if="item.isCyclic">
          <td colspan="3"></td>
          <td>
            <b>{{$t('buttons.cyclicItem')}}</b>
          </td>
          <td colspan="5">
            <b-row>
              <b-col cols="1" align-self="center">
                <span class="mr-3">
                  <b>{{$t('global.from')}}:</b>
                </span>
              </b-col>
              <b-col>
                <b-form-group>
                  <el-date-picker
                    :picker-options="{firstDayOfWeek: 1}"
                    class="d-inline-block"
                    id="date_from"
                    v-model="data.agreementAdditionalItems[index].dateFrom"
                    type="date"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd">
                  </el-date-picker>
                </b-form-group>
              </b-col>
              <b-col v-if="!item.timeless" cols="1" align-self="center">
                <span class="mr-3">
                  <b>{{$t('global.to')}}:</b>
                </span>
              </b-col>
              <b-col v-if="!item.timeless">
                <b-form-group>
                  <el-date-picker
                    :picker-options="{firstDayOfWeek: 1}"
                    class="d-inline-block"
                    id="date_to"
                    v-model="data.agreementAdditionalItems[index].dateTo"
                    type="date"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd">
                  </el-date-picker>
                </b-form-group>
              </b-col>
              <b-col align-self="center">
                <b-form-group>
                  <b-form-checkbox
                    v-model="data.agreementAdditionalItems[index].timeless"
                    :name="`additionaltimeless_${index}`"
                    :value="true"
                    :unchecked-value="false"
                    @input="setTimelessItem(index)">
                  <span>
                    {{$t('views.agreements.form.timelessCyclicItem')}}
                  </span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col align-self="center">
                <b-form-group>
                  <b-form-checkbox
                    v-model="data.agreementAdditionalItems[index].alwaysSettleInFull"
                    :name="`additionalalwaysSettleInFull_${index}`"
                    :value="1"
                    :unchecked-value="0">
                  <span>
                    {{$t('views.agreements.form.alwaysSettleInFull')}}
                  </span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
          </td>
        </tr>
        <tr v-if="item.hasPromotion">
          <td colspan="3"></td>
          <td>
            <b>{{$t('buttons.promotion')}}</b>
          </td>
          <td>
            <b v-if="item.item">{{$t('views.agreements.form.basePriceWithoutPromotion')}}: {{ getItemById(getCurrentItem(index).item).priceBrutto }}</b>
          </td>
          <td colspan="4">
            <model-select v-if="getPromotions.length > 0"
                          v-model="data.agreementAdditionalItems[index].promotion"
                          :options="getPromotions"
                          :placeholder="$t('views.agreements.form.select')"
                          name="promotion">
            </model-select>
          </td>
        </tr>
        <tr>
          <td colspan="3"></td>
          <td>
            <b>{{$t('views.agreements.form.additionalDocumentTemplate')}}</b>
          </td>
          <td colspan="5">
            <model-select v-model="data.agreementAdditionalItems[index].additionalDocumentTemplate"
                          :options="getDocumentTemplateOptions"
                          :placeholder="$t('views.agreements.form.select')"
                          name="additionalDocumentTemplate">
            </model-select>
          </td>
        </tr>
        </tbody>
      </table>
      <b-row>
        <b-col>
          <b-button class="btn float-left btn-primary" @click="addNewPosition()">{{ $t('views.exsbinvoices.form.addNewInvoicePosition') }}</b-button>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ModelSelect } from 'vue-search-select'
import addParamsToQuery from '@/utils/addParamsToQuery'
import getId from '@/utils/getIdFromLink'
import ApiService from '@/utils/ApiService'
import remove from '@/utils/remove'

export default {
  name: 'AgreementAdditionalItems',
  data () {
    return {
      priceUserDataObjects: [],
      priceOptions: [],
      isLoading: false
    }
  },

  props: ['data', 'violations', 'isInvalid', 'itemsFromAgreement', 'createAgreementItemsMulti'],

  components: {
    ModelSelect
  },

  computed: {
    isMassEdit () {
      return !!this.itemsFromAgreement || this.createAgreementItemsMulti
    },
    itemOptions () {
      if (this.itemsFromAgreement) {
        return this.itemsFromAgreement.map(entry => {
          return {
            value: entry['@id'],
            text: entry.name
          }
        })
      }
      if (!this.items) return []
      else {
        return this.items.map(entry => {
          return {
            value: entry['@id'],
            text: entry.name
          }
        })
      }
    },
    ...mapGetters({
      items: 'exsbitem/list/items',
      getPromotions: 'agreements/list/getPromotions',
      getDocumentTemplateOptions: 'agreements/list/getDocumentTemplateOptions'
    }),
    isUpdateRoute () {
      return this.$route.name === 'EXABAgreementsUpdate'
    }
  },

  watch: {
    'data.timelessAgreement': {
      immediate: true,
      handler (val) {
        this.data.agreementAdditionalItems.forEach(entry => {
          if (val && !entry.dateTo) entry.timeless = true
        })
      }
    },
    'data.dateFrom': {
      handler (val) {
        this.data.agreementAdditionalItems.forEach(entry => {
          if (entry.isCyclic) {
            entry.dateFrom = val
          }
        })
      }
    },
    'data.dateTo': {
      handler (val) {
        this.data.agreementAdditionalItems.forEach(entry => {
          if (entry.isCyclic) {
            entry.dateTo = val
          }
        })
      }
    },
    'data.idClient': {
      handler (val) {
        if (val) {
          if (!this.isUpdateRoute) this.data.agreementAdditionalItems = []
          this.fetchPriceUserData()
        }
      }
    },
    // watch for new items
    'data.agreementAdditionalItems': {
      deep: true,
      handler (val) {
        this.setIsCyclicItem(val)
        this.handlePriceOptions(val)
        this.handlePromotions(val)
      }
    },
    items (val) {
      if (!this.isLoading && this.isUpdateRoute && val.length > 0) {
        this.handlePriceOptions(this.data.agreementAdditionalItems)
      }
    }
  },

  created () {
  },

  methods: {
    getBoolean (val) {
      return Boolean(val)
    },
    getItemById (id) {
      return this.items.find(item => item['@id'] === id)
    },
    setTimelessItem (index) {
      if (this.getCurrentItem(index).timeless) this.getCurrentItem(index).dateTo = null
    },
    setIsCyclicItem (val) {
      if (!val) return
      val.forEach((item, index) => {
        if (item.item) this.data.agreementAdditionalItems[index].canBeCyclic = Boolean(this.getItemById(item.item).isCyclic)
        if (!this.data.agreementAdditionalItems[index].canBeCyclic) {
          this.data.agreementAdditionalItems[index].isCyclic = 0
        }
      })
    },
    handlePriceOptions (val) {
      if (!val) return
      val.forEach((item, index) => {
        // filter priceOptions for every item in agreement
        let options = this.priceUserDataObjects.filter(entry => {
          return entry.idItem['@id'] === item.item
        })
        this.setPriceOptionsForItem(options, index)
      })
    },
    handlePromotions (val) {
      if (!val) return
      val.forEach((item) => {
        if (!item.hasPromotion) {
          item.promotion = null
        }
        if (item.promotion) {
          item.hasPromotion = true
        }
      })
    },
    ...mapActions({
    }),
    setPriceOptionsForItem (options, index) {
      if (this.getCurrentItem(index).item === '') return
      this.priceOptions[index] = options.map(entry => {
        return {
          value: entry['@id'],
          text: this.$t('views.exsbpriceuserdata.list.customPrice') + ' - ' + entry.priceBrutto
        }
      })
      this.priceOptions[index].push({
        value: null,
        text: this.$t('views.exsbpriceuserdata.list.basePrice') + ' - ' + this.getItemById(this.getCurrentItem(index).item).priceBrutto
      })
    },
    hasItemCustomPrices (index) {
      if (!this.priceOptions[index]) return false
      return this.priceOptions[index].length > 1
    },
    removePosition (index) {
      let currentItem = this.data.agreementAdditionalItems[index]
      if (currentItem['@id']) {
        remove(currentItem['@id'], () => {
          this.data.agreementAdditionalItems.splice(index, 1)
          this.data.originalagreementAdditionalItems = JSON.stringify(this.data.agreementAdditionalItems)
        })
      } else {
        this.data.agreementAdditionalItems.splice(index, 1)
      }
    },
    addNewPosition () {
      this.data.agreementAdditionalItems.push({
        item: '',
        priceUserData: null,
        isCyclic: 0,
        alwaysSettleInFull: 0,
        dateFrom: this.data.dateFrom,
        dateTo: this.data.dateTo,
        timeless: Boolean(this.data.timelessAgreement),
        hasPromotion: false,
        promotion: null,
        additionalDocumentTemplate: null
      })
    },
    getPriceNetto (index) {
      return Math.round((this.getPriceBrutto(index) - this.getVatValue(index)) * 100) / 100
    },
    getPriceBrutto (index) {
      if (!this.getCurrentItem(index).item || this.items.length < 1) return 0
      let isCustomPriceSelected = (this.getCurrentItem(index).priceUserData && typeof this.getCurrentItem(index).priceUserData === 'string')
      if (isCustomPriceSelected) {
        return this.priceUserDataObjects.find(entry => {
          return entry.idItem['@id'] === this.getCurrentItem(index).item
        }).priceBrutto
      }
      let promotionId = (this.getCurrentItem(index).promotion)
      if (promotionId && this.getPromotions.length > 1) {
        let promotion = this.getPromotions.find(promotion => promotion.value === promotionId)
        let basePriceBrutto = this.getItemById(this.getCurrentItem(index).item).priceBrutto
        if (promotion.type === 0) { // Promocja kwotowa
          return (basePriceBrutto - promotion.promotionValue).toFixed(2)
        } else if (promotion.type === 1) { // Promocja procentowa
          return (basePriceBrutto - (promotion.promotionValue / 100) * basePriceBrutto).toFixed(2)
        }
      }
      return this.getItemById(this.getCurrentItem(index).item).priceBrutto
    },
    getVatRate (index) {
      if (!this.getCurrentItem(index).item || this.items.length < 1) return 0
      return this.getItemById(this.getCurrentItem(index).item).vatRate.value
    },
    getVatValue (index) {
      if (!this.getCurrentItem(index).item) return 0
      return Math.round(this.calculateVatValue(index) * 100) / 100
    },
    calculateVatValue (index) {
      return (this.getPriceBrutto(index) * this.getVatRate(index)) / (100 + this.getVatRate(index))
    },
    getCurrentItem (index) {
      if (!this.data.agreementAdditionalItems[index]) return null
      return this.data.agreementAdditionalItems[index]
    },
    async fetchPriceUserData () {
      this.isLoading = true
      let url = addParamsToQuery('e_x_s_b_price_user_datas', { idUserData: getId(this.data.idClient) })
      let params = { pagination: false }
      const response = await new ApiService(url, params).getResults()
      this.priceUserDataObjects = response.items
      this.isLoading = false
    }
  }
}
</script>
